function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { transparentize } from '../../../services';
import { euiYScroll } from '../../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "wtyx0k-euiPageSidebar",
  styles: "flex:0 1 0%;label:euiPageSidebar;"
} : {
  name: "wtyx0k-euiPageSidebar",
  styles: "flex:0 1 0%;label:euiPageSidebar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiPageSidebarStyles = function euiPageSidebarStyles(euiThemeContext) {
  var euiTheme = euiThemeContext.euiTheme;
  var embellishColor = transparentize(euiTheme.colors.lightShade, 0.3);
  return {
    euiPageSidebar: _ref,
    sticky: /*#__PURE__*/css(euiYScroll(euiThemeContext, {
      height: 'auto'
    }), " flex-grow:1;position:sticky;;label:sticky;"),
    embellish: /*#__PURE__*/css("background:linear-gradient(\n          160deg,\n          ", embellishColor, " 0,\n          ", embellishColor, " ", euiTheme.size.xl, ",\n          transparent 0\n        ),linear-gradient(\n          175deg,\n          ", embellishColor, " 0,\n          ", embellishColor, " ", euiTheme.size.base, ",\n          transparent 0\n        );;label:embellish;")
  };
};